import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { EntitlementService } from './entitlement.service';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const requiredPermission = route.data['permission'] as string | undefined;

  if (!requiredPermission) {
    console.error(
      `permissionGuard: falta "data.permission" en la ruta "${route.routeConfig?.path ?? ''}"`,
    );
    return router.parseUrl('/');
  }

  const entitlements = inject(EntitlementService);

  return entitlements
    .load()
    .pipe(
      map(() => (entitlements.hasPermission(requiredPermission) ? true : router.parseUrl('/'))),
    );
};
